import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import isNumber from 'lodash/isNumber';

export const stripNonNumericCharacters = (
  value: string | null | undefined | number,
): string =>
  isNonEmptyString(value)
    ? value.replace(/[^\.\d]/g, '')
    : isNumber(value)
      ? Math.abs(value).toString()
      : '';
